<template>
  <div v-if="pass" class="pass-card" :class="{ active, discount: pass.sale }">
    <div class="pass-card__cover">
      <img :src="pass.image_uri" alt="cover" />
    </div>
    <div class="pass-card__body">
      <div class="pass-card__name">{{ pass.name }}</div>
      <div class="pass-card__info">
        <div v-if="pass.sale" class="pass-card__discount ">
          <div class="pass-card__sale badge">Скидка: {{ pass.sale }}%</div>
          <span v-if="pass.sale">{{ pass.oldRubleAmount }} ₽</span>
        </div>

        <div v-if="pass.salesHit" class="pass-card__sales-hit badge">
          <Icon size="sm" name="/base/bomb.svg" />
          <span>{{ $t('superPass.pass.salesHit') }}</span>
        </div>

        <div class="pass-card__price">
          {{ pass.amount[$store.state.currency] }}
          {{ currencyMap[$store.state.currency] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './passCard.scss'
import Icon from '@/components/Base/Icon/Icon.vue'

export default {
  name: 'PassCard',
  components: { Icon },
  inject: ['currencyMap'],

  props: {
    pass: {
      type: Object,
      default: () => {}
    },
    current: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    active() {
      return this.pass.id === this.current.id
    }
  }
}
</script>
